var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _path3, _rect8, _rect9, _rect10, _rect11, _path4, _rect12, _rect13, _rect14, _rect15, _path5, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path6, _g, _path7, _path8, _rect33, _path9, _rect34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 330 663",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.3591,
    y: 0.37328,
    width: 323.28,
    height: 662.24,
    rx: 52.636,
    fill: "#DFD2CF",
    stroke: "#121511",
    strokeWidth: 0.74661
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2266,
    y: 2.2398,
    width: 319.55,
    height: 658.51,
    rx: 51.516,
    fill: "#4E4A49"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2109,
    y: 5.2263,
    width: 313.58,
    height: 652.53,
    rx: 48.529,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m133.64 5.2263h62.714c0 1.6494-1.337 2.9864-2.986 2.9864h-56.742c-1.649 0-2.986-1.3371-2.986-2.9864z",
    fill: "url(#e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0.74661 127.86h2.0532v24.265h-2.0532c-0.30926 0-0.55995-0.251-0.55995-0.56v-23.145c0-0.309 0.2507-0.56 0.55995-0.56z",
    fill: "#8E8A87",
    stroke: "#514D4A",
    strokeWidth: 0.3733
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 129.16,
    width: 1.4932,
    height: 21.652,
    fill: "#5C5A57"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 2.9844 129.16)",
    width: 0.74661,
    height: 21.652,
    fill: "#312E2B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 150.81,
    width: 1.4932,
    height: 0.74661,
    fill: "#0C0A09"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 129.16,
    width: 1.4932,
    height: 0.74661,
    fill: "#0C0A09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0.74661 174.89h2.0532v48.157h-2.0532c-0.30926 0-0.55995-0.251-0.55995-0.56v-47.037c0-0.309 0.2507-0.56 0.55995-0.56z",
    fill: "#8E8A87",
    stroke: "#514D4A",
    strokeWidth: 0.3733
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 177.65,
    width: 1.4932,
    height: 42.647,
    fill: "#5C5A57"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 2.9844 177.65)",
    width: 0.74661,
    height: 42.647,
    fill: "#312E2B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 219.55,
    width: 1.4932,
    height: 1.4706,
    fill: "#0C0A09"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 177.65,
    width: 1.4932,
    height: 1.4706,
    fill: "#0C0A09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m329.25 283.52h-2.053v-74.288h2.053c0.31 0 0.56 0.251 0.56 0.56v73.168c0 0.309-0.25 0.56-0.56 0.56z",
    fill: "#8E8A87",
    stroke: "#514D4A",
    strokeWidth: 0.3733
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(180 328.51 279.19)",
    x: 328.51,
    y: 279.19,
    width: 1.4932,
    height: 65.611,
    fill: "#5C5A57"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 327.02 279.19)",
    width: 0.74661,
    height: 65.611,
    fill: "#312E2B"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(180 328.51 214.72)",
    x: 328.51,
    y: 214.72,
    width: 1.4932,
    height: 2.2624,
    fill: "#0C0A09"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(180 328.51 279.19)",
    x: 328.51,
    y: 279.19,
    width: 1.4932,
    height: 2.2624,
    fill: "#0C0A09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0.74661 238.35h2.0532v48.156h-2.0532c-0.30926 0-0.55995-0.25-0.55995-0.56v-47.036c0-0.309 0.2507-0.56 0.55995-0.56z",
    fill: "#8E8A87",
    stroke: "#514D4A",
    strokeWidth: 0.3733
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 241.11,
    width: 1.4932,
    height: 42.647,
    fill: "#5C5A57"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 2.9844 241.11)",
    width: 0.74661,
    height: 42.647,
    fill: "#312E2B"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 283.01,
    width: 1.4932,
    height: 1.4706,
    fill: "#0C0A09"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4941,
    y: 241.11,
    width: 1.4932,
    height: 1.4706,
    fill: "#0C0A09"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9902,
    y: 70.181,
    width: 5.2262,
    height: 4.4796,
    fill: "#31302E"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9902,
    y: 70.181,
    width: 1.7421,
    height: 4.4796,
    fill: "#4C4948"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9902,
    y: 588.33,
    width: 5.2262,
    height: 4.4796,
    fill: "#31302E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9902,
    y: 588.33,
    width: 1.7421,
    height: 4.4796,
    fill: "#4C4948"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(180 327.01 592.8)",
    x: 327.01,
    y: 592.8,
    width: 5.2262,
    height: 4.4796,
    fill: "#31302E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(180 327.01 592.8)",
    x: 327.01,
    y: 592.8,
    width: 1.7421,
    height: 4.4796,
    fill: "#4C4948"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(180 327.01 74.661)",
    x: 327.01,
    y: 74.661,
    width: 5.2262,
    height: 4.4796,
    fill: "#31302E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(180 327.01 74.661)",
    x: 327.01,
    y: 74.661,
    width: 1.7421,
    height: 4.4796,
    fill: "#4C4948"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 256.83 0)",
    x: 256.83,
    width: 5.2262,
    height: 4.4796,
    fill: "#31302E"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 256.83 0)",
    x: 256.83,
    width: 1.7421,
    height: 4.4796,
    fill: "#4C4948"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90 73.172 662.99)",
    x: 73.172,
    y: 662.99,
    width: 5.2262,
    height: 4.4796,
    fill: "#31302E"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90 73.172 662.99)",
    x: 73.172,
    y: 662.99,
    width: 1.7421,
    height: 4.4796,
    fill: "#4C4948"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 19.797,
    y: 16.579,
    width: 288.51,
    height: 629.83,
    rx: 40,
    fill: "#FCFBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m50.09 30.245c2.1723 0 3.7262 1.5086 3.7262 3.3641 0 1.2521-0.4375 2.0517-1.3427 3.168l-3.0624 3.8016h-1.7499l3.002-3.7413c-0.3017 0.1056-0.6034 0.1509-0.89 0.1509-1.9762 0-3.4245-1.3426-3.4245-3.3038 0-1.9309 1.5689-3.4395 3.7413-3.4395zm-0.0151 1.2823c-1.2069 0-2.1422 0.8448-2.1422 2.112 0 1.3426 0.9353 2.1572 2.1422 2.1572 1.1918 0 2.1573-0.7241 2.1573-2.1421 0-1.2823-0.9655-2.1271-2.1573-2.1271zm7.0342 2.2025c0 0.6788-0.4677 1.1616-1.1616 1.1616-0.6789 0-1.1616-0.4828-1.1616-1.1616 0-0.694 0.4827-1.1767 1.1616-1.1767 0.6939 0 1.1616 0.4827 1.1616 1.1767zm0 5.7627c0 0.6789-0.4677 1.1616-1.1616 1.1616-0.6789 0-1.1616-0.4827-1.1616-1.1616 0-0.709 0.4827-1.1917 1.1616-1.1917 0.6939 0 1.1616 0.4827 1.1616 1.1917zm8.6509-1.1616h-1.3878v2.2478h-1.5237v-2.2478h-4.9029v-1.0711l5.2499-6.879h1.1767v6.6226h1.3878v1.3275zm-6.1097-1.3275h3.1982v-4.3145l-3.1982 4.3145zm9.8847 3.5753h-1.5387v-8.8704h-1.9763v-1.3275h3.515v10.198z",
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.01,
    y: 22.579,
    width: 93.75,
    height: 26.27,
    rx: 13.135,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.39,
    cy: 36.079,
    rx: 3.375,
    ry: 3.2838,
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.39,
    cy: 36.079,
    rx: 1.875,
    ry: 2.554,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.77,
    cy: 34.985,
    rx: 1.5,
    ry: 1.4595,
    fill: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.76,
    cy: 37.904,
    rx: 0.75,
    ry: 0.72973,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.76,
    cy: 37.904,
    rx: 0.75,
    ry: 0.72973,
    fill: "url(#a)",
    fillOpacity: 0.2
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m240.7 31.622c-0.47 0-0.851 0.3811-0.851 0.8512v7.3621c0 0.4701 0.381 0.8512 0.851 0.8512h0.691c0.47 0 0.851-0.3811 0.851-0.8512v-7.3621c0-0.4701-0.381-0.8512-0.851-0.8512h-0.691zm-4.014 1.8189c-0.47 0-0.851 0.3811-0.851 0.8512v5.5433c0 0.4701 0.381 0.8512 0.851 0.8512h0.692c0.47 0 0.851-0.3811 0.851-0.8512v-5.5433c0-0.4701-0.381-0.8512-0.851-0.8512h-0.692zm-4.867 2.8204c0-0.4701 0.381-0.8512 0.852-0.8512h0.691c0.47 0 0.851 0.3811 0.851 0.8512v3.5742c0 0.4701-0.381 0.8512-0.851 0.8512h-0.691c-0.471 0-0.852-0.3811-0.852-0.8512v-3.5742zm-3.164 0.9075c-0.47 0-0.851 0.3811-0.851 0.8512v1.8154c0 0.4701 0.381 0.8512 0.851 0.8512h0.691c0.47 0 0.852-0.3811 0.852-0.8512v-1.8154c0-0.4701-0.382-0.8512-0.852-0.8512h-0.691z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m258.45 35.78c-3.047-3.0471-7.987-3.0471-11.034 0l-1.324-1.3241c3.778-3.7784 9.904-3.7784 13.683 0l-1.325 1.3241zm-2.208 2.1746c-1.826-1.8256-4.786-1.8256-6.611 0l-1.324-1.3242c2.556-2.5568 6.702-2.5568 9.259 0l-1.324 1.3242zm-5.517 0.6784c1.241-1.2412 3.253-1.2412 4.495 0l-1.991 2.0037c-0.133 0.1333-0.348 0.1341-0.481 0.0018l-2.023-2.0055z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 264.75,
    y: 32.917,
    width: 16.806,
    height: 8.4031,
    rx: 2.661,
    opacity: 0.35,
    stroke: "#000",
    strokeWidth: 0.70026
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m282.54 35.834v2.801c0.564-0.2372 0.93-0.7891 0.93-1.4005s-0.366-1.1633-0.93-1.4005",
    fill: "#000",
    opacity: 0.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 33.967,
    width: 14.702,
    height: 6.3023,
    rx: 1.7506,
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 194.26,
    y: 32.045,
    width: 8.25,
    height: 8.0676,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1892_5772",
    stdDeviation: 0.375
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 195.76,
    y: 32.775,
    width: 5.25,
    height: 6.6082,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1892_5772",
    stdDeviation: 0.375
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 196.52,
    y: 32.775,
    width: 4.5,
    height: 4.419,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1892_5772",
    stdDeviation: 0.375
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 197.26,
    y: 36.424,
    width: 3,
    height: 2.9595,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1892_5772",
    stdDeviation: 0.375
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 165,
    x2: 165,
    y1: 5.2263,
    y2: 8.2127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0806",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(198.39 36.079) rotate(90) scale(3.2838 3.375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060B43",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060B43",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(198.77 34.62) rotate(90) scale(1.0946 1.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5164C2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F094D",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(198.76 37.721) rotate(90) scale(.72973 .75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00445A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#491F78",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 198.2,
    x2: 199.51,
    y1: 38.086,
    y2: 38.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14086C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A56",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(117 22.579)",
    width: 93.75,
    height: 27,
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.53b1e54fb1616f605a53b4d04d32b8ea.svg";
export { ForwardRef as ReactComponent };